module.exports = __webpack_public_path__ + "img/Golden-Mix-Frontal.4f47663b.jpg";